/**
 * Persistent visual indicator shown only when the surrounding settings
 * tree is mounted under an admin-target route. In the normal self-mode
 * this component renders `null` and the user sees no change.
 */
import { Link } from 'react-router-dom';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { useIsAdminMode, useTargetUid } from '../auth/TargetUidContext';
import { useAdminUsers } from '../hooks/useAdminUsers';

export function AdminContextBanner() {
  const adminMode = useIsAdminMode();
  const targetUid = useTargetUid();
  const users = useAdminUsers();
  if (!adminMode || !targetUid) return null;
  const target = users.data?.find((u) => u.uid === targetUid);
  const label = target?.email ?? target?.displayName ?? targetUid;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-md border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-sm text-amber-100">
      <span className="inline-flex items-center gap-2">
        <ShieldAlert className="h-4 w-4 text-amber-400" />
        Du bearbeitest die Einstellungen von <strong className="font-semibold">{label}</strong>.
        Änderungen wirken beim nächsten Anruf dieses Benutzers (≤ 60 s Cache).
      </span>
      <Link
        to="/admin/users"
        className="inline-flex items-center gap-1 rounded-md border border-amber-500/40 px-2 py-1 text-xs hover:bg-amber-500/10"
      >
        <ArrowLeft className="h-3.5 w-3.5" /> Zurück zur Benutzerliste
      </Link>
    </div>
  );
}
